import { lazy, Suspense } from "react";
import MgpMessage from "../../elements/MgpMessage/MgpMessage";
import { isSupportedDocViewerBrower } from "../../utils/utils";
import ImageViewer from "./ImageViewer";


export type ImageAndPdfViewerProps = {
    file: File,
    pageWidth?: number,
    type?: string,
    isSinglePage?: boolean
}



const PdfViewer = lazy(() => import('./PdfViewer'));

export default function ImageAndPdfViewer(props: ImageAndPdfViewerProps) {
    let extension = props.type;
    if (!extension) {
        const filename = props.file.name?.toLowerCase();
        const splitNames = filename.split('.');
        extension = splitNames[splitNames.length - 1];
    }

   
    const isSupportedDocViewer = isSupportedDocViewerBrower();
    if (extension === 'pdf') {
        return (
            <>
            <Suspense fallback={<div>Loading</div>}>
              { isSupportedDocViewer ? <PdfViewer  {...props}/> :  <MgpMessage type="warning" message="L'aperçu du document n'est pas pris en charge" /> }
            </Suspense>
          </>
        );
    }
    return (
        <ImageViewer {...props}></ImageViewer>
    );
}
